import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import PartnersGrid from "@/components/PartnersGrid";
import { IMAGES } from "@/lib/data";
import { useLang } from "@/i18n";

export default function Partners() {
  const { t } = useLang();

  return (
    <>
      <SEO
        title="Partners — Trusted Across the Supply Chain | Farmsons"
        description="Farmsons works with partners across the produce supply chain, including Adani Farm-Pik, Bija Agrifresh and NatureNest, to move fruit from orchard to market and export."
        keywords="Farmsons partners, Adani Farm-Pik, Bija Agrifresh, produce supply chain India"
      />
      <PageHeader
        overline={t("partnersPage.overline")}
        title={t("partnersPage.title")}
        lede={t("partnersPage.lede")}
        image={IMAGES.shipping}
        imageAlt="Cargo containers at an export port, representing Farmsons' supply-chain partnerships"
      />
      <section className="pb-24 md:pb-32 bg-[#fdfbf5]">
        <PartnersGrid heading={false} />
      </section>
    </>
  );
}
